module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "order-vendor-information"
  }, [_c('div', {
    staticClass: "option-container main-option-container"
  }, [_c('div', {
    staticClass: "option2",
    class: {
      'option-active': _vm.delivery.withCarry == 1
    },
    on: {
      "click": function($event) {
        return _vm.setDeliveryType(1)
      }
    }
  }, [_c('p', [_vm._v("Dostawa z wniesieniem")])]), _vm._v(" "), _c('div', {
    staticClass: "option2",
    class: {
      'option-active': _vm.delivery.withCarry == 0
    },
    on: {
      "click": function($event) {
        return _vm.setDeliveryType(0)
      }
    }
  }, [_c('p', [_vm._v("Dostawa bez wniesienia")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header mb-20"
  }, [_c('i', {
    staticClass: "ion-gear-a"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybierz rodzaj dostawy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-758a936d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeliveryTypeBox.vue
// module id = 259
// module chunks = 1